import React from 'react';
import { BookOpenIcon, BrainIcon, VideoIcon, GraduationCapIcon, CheckIcon } from 'lucide-react';
export function HeroSection() {
  return <>
      {/* Banner fino de oferta */}
      <div className="w-full bg-[#c41e3a] py-1.5 px-4 overflow-hidden" data-id="element-110">
        <div className="animate-scroll-right" data-id="element-111">
          <p className="text-white text-xs md:text-sm font-black tracking-widest whitespace-nowrap uppercase" data-id="element-112">
            💈 Oferta por lanzamiento — 60% de descuento · Acceso inmediato ·
            100% online 💈 Oferta por lanzamiento — 60% de descuento · Acceso
            inmediato · 100% online
          </p>
        </div>
      </div>

      <section className="w-full bg-[#0a0a0a] py-8 md:py-16 lg:py-20 px-4 relative" data-id="element-113">
        {/* Logo flotante */}
        <div className="fixed top-4 left-4 z-50" data-id="element-114">
          <img src="https://cdn.magicpatterns.com/uploads/nTBDp8jLQqs428HDhKddZJ/ChatGPT_Image_24_feb_2026,_12_38_15_a.m..png" alt="Barber Pro Academy Logo" className="w-12 h-12 md:w-16 md:h-16 drop-shadow-2xl" data-id="element-115" />
        </div>

        <div className="max-w-4xl mx-auto" data-id="element-116">
          <div className="text-center mb-8 md:mb-14" data-id="element-117">
            {/* Pre-headline — aspiracional */}
            <p className="text-xs md:text-sm text-[#c41e3a] mb-3 font-black tracking-widest uppercase" data-id="element-118">
              Formación digital en barbería · Ebook + Videos
            </p>

            {/* Título principal H1 */}
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-black leading-tight text-white mb-4 md:mb-5" data-id="element-119">
              Aprendé barbería con un método claro,{' '}
              <span className="text-[#c41e3a]" data-id="element-120">aplicable y real</span>
            </h1>

            {/* Línea decorativa */}
            <div className="w-16 md:w-24 h-1 bg-[#c41e3a] mx-auto mb-4 md:mb-5" data-id="element-121"></div>

            {/* Subtítulo — directo y aspiracional */}
            <p className="text-base md:text-xl text-gray-300 leading-relaxed max-w-2xl mx-auto mb-6 md:mb-8" data-id="element-122">
              Tanto si estás empezando como si ya cortás y querés mejorar tus
              resultados — esta formación te da el criterio profesional que los
              videos sueltos no te dan.
            </p>

            {/* Bullets con lenguaje de resultado */}
            <div className="max-w-xl mx-auto mb-6 md:mb-10 space-y-2 text-left" data-id="element-123">
              {['Vas a entender cada corte, no solo ejecutarlo', 'Vas a trabajar con criterio desde el primer día', 'Te ayuda a ordenar tu técnica y mejorar resultados reales', 'Tenés el material para consultar siempre que lo necesités'].map(bullet => <div key={bullet} className="flex items-start gap-2 text-gray-200" data-id="element-124">
                  <CheckIcon className="w-4 h-4 md:w-5 md:h-5 text-[#c41e3a] flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-125" />
                  <span className="text-sm md:text-base font-semibold" data-id="element-126">
                    {bullet}
                  </span>
                </div>)}
            </div>
          </div>

          {/* Imagen principal */}
          <div className="flex justify-center mb-8 md:mb-12" data-id="element-127">
            <img src="https://cdn.magicpatterns.com/uploads/xxiNDAdA5WvE8qmHCeXCdE/Gemini_Generated_Image_y45kpy45kpy45kpy.png" alt="Método Barber Pro - Formación profesional en barbería" className="w-48 md:w-72 lg:w-80 rounded-lg shadow-2xl" data-id="element-128" />
          </div>

          {/* Cards de características — lenguaje de beneficio */}
          <div className="max-w-3xl mx-auto mb-8 md:mb-12" data-id="element-129">
            <div className="grid grid-cols-2 gap-3 md:gap-4" data-id="element-130">
              <div className="flex items-center gap-3 text-gray-200 bg-[#111] p-3 md:p-5 rounded-lg border border-gray-700" data-id="element-131">
                <BookOpenIcon className="w-6 h-6 md:w-8 md:h-8 text-[#c41e3a] flex-shrink-0" aria-hidden="true" data-id="element-132" />
                <span className="text-xs md:text-sm font-semibold leading-snug" data-id="element-133">
                  Ebooks descargables para estudiar a tu ritmo
                </span>
              </div>
              <div className="flex items-center gap-3 text-gray-200 bg-[#111] p-3 md:p-5 rounded-lg border border-gray-700" data-id="element-134">
                <BrainIcon className="w-6 h-6 md:w-8 md:h-8 text-[#c41e3a] flex-shrink-0" aria-hidden="true" data-id="element-135" />
                <span className="text-xs md:text-sm font-semibold leading-snug" data-id="element-136">
                  Método estructurado paso a paso
                </span>
              </div>
              <div className="flex items-center gap-3 text-gray-200 bg-[#111] p-3 md:p-5 rounded-lg border border-gray-700" data-id="element-137">
                <VideoIcon className="w-6 h-6 md:w-8 md:h-8 text-[#c41e3a] flex-shrink-0" aria-hidden="true" data-id="element-138" />
                <span className="text-xs md:text-sm font-semibold leading-snug" data-id="element-139">
                  Videos de apoyo para ver técnicas en acción
                </span>
              </div>
              <div className="flex items-center gap-3 text-gray-200 bg-[#111] p-3 md:p-5 rounded-lg border border-gray-700" data-id="element-140">
                <GraduationCapIcon className="w-6 h-6 md:w-8 md:h-8 text-[#c41e3a] flex-shrink-0" aria-hidden="true" data-id="element-141" />
                <span className="text-xs md:text-sm font-semibold leading-snug" data-id="element-142">
                  Certificado al completar la formación
                </span>
              </div>
            </div>
          </div>

          {/* CTA — más presencia visual */}
          <div className="flex flex-col items-center gap-2" data-id="element-143">
            <a href="#pricing" className="cta-primary text-white font-black text-base md:text-xl px-10 md:px-14 py-4 md:py-5 rounded-lg inline-block text-center" aria-label="Acceder a la formación" data-id="element-144">
              👉 Quiero acceder al Método Barber Pro
            </a>
            <p className="text-gray-500 text-xs font-semibold" data-id="element-145">
              Acceso inmediato · 100% online · Sin vencimiento
            </p>
          </div>
        </div>
      </section>
    </>;
}